var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-wrapper"},[_c('Table',_vm._b({key:_vm.height,staticClass:"io-table",staticStyle:{"border":"1px solid #eee"},attrs:{"height":_vm.height}},'Table',_vm.table,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }